import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from 'src/app/data/handlers/request/request.service';
import { talonOneApi } from '../../api/talon-one/talon-one.api'
import { globalEnv } from '../../connection/global/global.env';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Descriptions as ResponseInfoFAQTalonOne } from '../../models/farmacredits/faq/faq';
import { TransactionDataToSend, Transactions as ResponseTransactionsTalonOne } from '../../models/farmacredits/transactions/transaction';
import { Credits as ResponseCreditsTalonOne } from '../../models/farmacredits/credits/credits';


@Injectable({
  providedIn: 'root'
})
export class TalonOneService {
  constructor(private req: RequestService, private http: HttpClient) { }


  sendEventTalonOne(data): Observable<any> {
    return this.req.post(`${globalEnv.be2}${talonOneApi.host}`, data, null)
  }

  sendEventTalonOne2(data): Observable<any> {
    return this.req.post(`${globalEnv.talonOne}${talonOneApi.host2}`, data, null)
  }

  getItemsAnonymousTalonOne(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this.http.get(`${globalEnv.cloudFunction}${talonOneApi.anonymousItems}`, httpOptions);
  }

  getCreditsTalonOne(customerId: number): Observable<ResponseCreditsTalonOne> {
    const url: string = `${globalEnv.gateway}${talonOneApi.credits}`
      .replace(':customerId', customerId?.toString());
    return this.req.get(url, null)
  }

  getTransactionsTalonOne(data: TransactionDataToSend): Observable<ResponseTransactionsTalonOne> {
    const { customerId, params } = data
    const url: string = `${globalEnv.gateway}${talonOneApi.transactions}`
      .replace(':customerId', customerId?.toString());
    return this.req.get(url, params);
  }

  getInfoTalonOne(): Observable<ResponseInfoFAQTalonOne> {
    return this.req.get(`${globalEnv.gateway}${talonOneApi.info}`)
  }
}
